/**
 * お届け先の配達料等に関連する情報を返却
 */

var DeliveryInfomation = DeliveryInfomation || {};


/**
 * 指定した条件でお届け先の配達料に関する情報を返却
 *
 * @param int storeId
 * @param int prefCode
 * @param int cityCode
 *
 * @return Deferred
 */
DeliveryInfomation.getDeliveryinformation = function(storeId, prefCode, cityCode) {
	var params = {
		storeId: storeId,
		prefCode: prefCode,
		cityCode: cityCode,
	};

	var defer = $.Deferred();
	$.ajax({
		url: '/service/delivery-information.json',
		method: 'GET',
		data: params,
		cache: true,
		success: defer.resolve,
		error: defer.reject
	});

	return defer.promise();
};

/**
 * お届け出来る市町村区を返却.
 *
 * @param int storeId
 * @param int prefCode
 *
 * @return Deferred
 */
DeliveryInfomation.getAvailableDeliveryCities = function(storeId, prefCode) {
	var params = {
		storeId: storeId,
		prefCode: prefCode,
	};

	var defer = $.Deferred();
	$.ajax({
		url: '/service/available-delivery-cities.json',
		method: 'GET',
		data: params,
		cache: true,
		success: defer.resolve,
		error: defer.reject
	});

	return defer.promise();
};

/**
 * パターンによって切り替えるフラグを返却.
 *
 * @param string type
 *
 * @return object
 */
DeliveryInfomation.showDisplay = function(type) {
	var params = {};

	switch (type) {
		case 'reset':
			params.showUnselected          = true;
			params.showUnAvailableArea     = false;
			params.showDeliveryInformation = false;
			params.showAvailableArea       = false;
			break;

		case 'available':
			params.showDeliveryInformation = true;
			params.showAvailableArea       = true;
			params.showUnAvailableArea     = false;
			break;

		case 'unavailable':
			params.showDeliveryInformation = false;
			params.showAvailableArea       = false;
			params.showUnAvailableArea     = true;
			break;
	}

	return params;
};
